import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../../components/common/backButton";
import Toast from "../../components/common/toast";
import userHooks from "../../hooks/userHooks";
import useAuthStore from "../../store/authStore";

function isValidPhone(phone) {
  return /^01[016789]-?\d{3,4}-?\d{4}$/.test(phone);
}

const formatPhoneNumber = (value) => {
  const numbers = value.replace(/[^\d]/g, "");

  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 7) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  } else {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
      7,
      11
    )}`;
  }
};

const MyInfo = () => {
  const navigate = useNavigate();
  const userInfo = useAuthStore((state) => state.userInfo);
  const accessToken = userInfo.accessToken;

  const [phone, setPhone] = useState(
    userInfo.hp ? formatPhoneNumber(userInfo.hp) : ""
  );
  // eslint-disable-next-line no-unused-vars
  const [name, setName] = useState(userInfo.user_name);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    const formattedValue = formatPhoneNumber(value);
    setPhone(formattedValue);
    setHasError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidPhone(phone)) {
      setHasError(true);
      return;
    }

    try {
      setIsLoading(true);

      if (!accessToken) {
        setToastMessage("로그인이 필요합니다.");
        setIsToastOpen(true);
        return;
      }

      const response = await userHooks.changePhoneNumberHooks({
        hp: phone,
      });

      if (response.IsError) {
        setToastMessage("전화번호 변경에 실패했습니다. 다시 시도해주세요.");
        setIsToastOpen(true);
        return;
      }

      const updatedUserInfo = {
        ...userInfo,
        hp: response.hp,
      };

      useAuthStore.setState({
        userInfo: updatedUserInfo,
      });

      setToastMessage("전화번호가 변경되었습니다.");
      setIsToastOpen(true);
      setTimeout(() => {
        navigate("/mypage");
      }, 2000);
    } catch (error) {
      console.error(error);
      setToastMessage("오류가 발생했습니다. 다시 시도해주세요.");
      setIsToastOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="flex flex-col bg-white pt-[3.125rem] md:pt-[4.375rem]"
      style={{
        minHeight: "calc(var(--vh, 1vh) * 100)",
        paddingBottom: "max(1.875rem, env(safe-area-inset-bottom))",
      }}
    >
      <BackButton text="전화번호 수정" />
      <form className="flex flex-col gap-[36px] pt-[154px] px-[23px] md:px-[150px]">
        <input
          type="text"
          placeholder="이름"
          value={name}
          readOnly
          className="border-b h-[31px] md:h-[40px] flex items-center text-[18px] md:text-xl placeholder:text-[#BDBEC6] focus:outline-none"
        />
        <input
          type="tel"
          placeholder="010-1234-5678"
          className="border-b h-[31px] md:h-[40px] flex items-center text-[18px] md:text-xl placeholder:text-[#BDBEC6] focus:outline-none"
          value={phone}
          onChange={handleChange}
          maxLength={13}
        />
        {hasError && (
          <span className="text-red-500 text-[13px] mt-[-12px]">
            올바른 전화번호를 입력해 주세요.
          </span>
        )}
      </form>

      <div className="fixed bottom-[50px] left-0 right-0 px-[23px] z-50">
        <div className="flex justify-center max-w-[754px] mx-auto">
          <button
            type="button"
            className={`w-full h-[54px] rounded-[8px] font-semibold text-[15px] md:text-lg transition ${
              isValidPhone(phone) && !isLoading
                ? "bg-[#FEC009] text-white"
                : "bg-[#E9EAEE] text-[#CCCCCC] cursor-not-allowed"
            }`}
            disabled={!isValidPhone(phone) || isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>

      <Toast
        isOpen={isToastOpen}
        message={toastMessage}
        onClose={() => setIsToastOpen(false)}
      />
    </div>
  );
};

export default MyInfo;
